import { render } from "./RefLink.vue?vue&type=template&id=d4a68964"
import script from "./RefLink.vue?vue&type=script&lang=js"
export * from "./RefLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__